import React from 'react';

import { Button } from '@gogame/components';

export const DialogSubmitButton = ({
  label = 'Save',
  disabled,
  onSubmit,
  ...props
}) => {
  return (
    <Button
      disabled={disabled}
      variant={'contained'}
      role={'button'}
      onClick={onSubmit}
      {...props}
    >
      {label}
    </Button>
  );
};
